const DOMAIN = 'cobranded.services.userSettings.privateArea.commons.';

const COPIED = `${DOMAIN}copiedLink`;

const ERROR_EXIT_LINK = `${DOMAIN}genericError.exitLink`;

const GO_TO_FINANCING = `${DOMAIN}goToFinancing`;

const NOT_AVAILABLE = `${DOMAIN}notAvailable`;

const WIZARD = {
  TEXT_SEPARATOR: `${DOMAIN}wizard.textSeparator`,
};

const PRODUCT_NAME = 'Cobranded_ProductName';

export { COPIED, ERROR_EXIT_LINK, NOT_AVAILABLE, GO_TO_FINANCING, WIZARD, PRODUCT_NAME };
